import React from 'react';
import { Circle } from 'rc-progress';
import styled from 'styled-components';

const ProgressCircleContainer = styled.div`
    position: relative;
`;

const ProgressCircleCount = styled.div`
    position: absolute;
    width: 100%;
    height: 100%;
    top: 0;
    display: flex;
    align-items: center;
    justify-content: center;
    font-family: Monaco;
    font-size: 10px;
`;

export const ProgressCircle = ({
    percent,
    total,
    className,
}: {
    percent: number,
    total: number,
    className?: string,
}) => (
    <ProgressCircleContainer className={className}>
        <Circle strokeWidth={5} percent={percent} />
        <ProgressCircleCount>
            <div>{Math.max((percent * total) / 100000, 0).toFixed(2)}s</div>
        </ProgressCircleCount>
    </ProgressCircleContainer>
);
